import React from "react";
import { CardContainer } from "../../../components/Card";
import { LineChart } from "../../../components/Charts";

export default function InvoiceTab({ data }) {
    return (
        <CardContainer>
            <LineChart
                data={data}
                series={[
                    {
                        name: "Invoiced",
                        key: "invoiced",
                    },
                ]}
                xKey="week"
                title="Invoiced"
            />
        </CardContainer>
    );
}
